import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { DEX_API_WEB_URL } from 'src/constants';
import { customHeaders } from 'src/store/shared/rtkHeaders/helpers';

import { ReauthBaseQuery } from '@skynet/data-auth-api';

const customBaseQuery = fetchBaseQuery({
  baseUrl: DEX_API_WEB_URL,
  // @ts-expect-error to avoid the use of `getState as () => RootState`
  prepareHeaders: (headers, { getState }) => customHeaders(headers, getState),
});

export const rtkDexApi = createApi({
  reducerPath: 'DexApi',
  tagTypes: [
    'Dex',
    'DexVaults',
    'DexToWei',
    'DexTasks',
    'TokenValidation',
    'DexPool',
    'BittensorValidators',
  ],
  baseQuery: ReauthBaseQuery(customBaseQuery),
  endpoints: (_builder) => ({}),
});
